import { z } from "zod";
import { defineEvent } from "./_define";
import { baseEnvelopeSchema } from "./_envelope";

export const ENTRYPOINT_VIEWED_VALUES = {
  TRIAGE: "triage",
  DISMISSIBLE_CTA: "dismissible_cta",
  FAB: "fab",
  DEEP_LINK: "deep_link",
  PUSH: "push",
  EMAIL: "email",
  HOME: "home",
  UNKNOWN: "unknown",
} as const;

export type EntrypointViewedValue =
  (typeof ENTRYPOINT_VIEWED_VALUES)[keyof typeof ENTRYPOINT_VIEWED_VALUES];

export const entrypointViewed = defineEvent({
  eventName: "entrypoint_viewed",
  eventVersion: 2,
  valueSchema: z.enum([
    ENTRYPOINT_VIEWED_VALUES.TRIAGE,
    ENTRYPOINT_VIEWED_VALUES.DISMISSIBLE_CTA,
    ENTRYPOINT_VIEWED_VALUES.FAB,
    ENTRYPOINT_VIEWED_VALUES.DEEP_LINK,
    ENTRYPOINT_VIEWED_VALUES.PUSH,
    ENTRYPOINT_VIEWED_VALUES.EMAIL,
    ENTRYPOINT_VIEWED_VALUES.HOME,
    ENTRYPOINT_VIEWED_VALUES.UNKNOWN,
  ]),
  metadataSchema: baseEnvelopeSchema
    .extend({
      subscription_status: z.string().optional(),
    })
    .passthrough(),
});
